// Fixed cart UI wording only; backend content uses per-field Arabic fallback.
export const cartDict: { en: Record<string, string>; ar: Record<string, string> } = {
  "en": {
    "cart.selection": "Your Selection",
    "cart.title": "Shopping Cart",
    "cart.yourCart": "Your Cart",
    "cart.empty": "Your cart is empty",
    "cart.journey": "Start your fragrance journey to create your personalized perfume.",
    "cart.getStarted": "Create your personalized perfume to get started.",
    "cart.create": "Create Your Scent",
    "cart.signature": "ANAYA Signature Box",
    "cart.single": "Single Perfume",
    "cart.greeting": "✓ Greeting card included",
    "cart.photoIncluded": "✓ Photo included",
    "cart.remove": "Remove",
    "cart.total": "Total",
    "cart.addCollectionFull": "Add More from Anaya Collection",
    "cart.addQuiz": "Add More (Quiz Options)",
    "cart.proceed": "Proceed to Checkout",
    "cart.savedLater": "Saved for Later",
    "cart.savedDescription": "Orders from your sample purchases - ready to complete anytime",
    "cart.signatureFallback": "Signature Box",
    "cart.saved": "Saved",
    "cart.recipient": "recipient",
    "cart.added": "Added to Cart",
    "cart.savedAdded": "Your saved order has been added to the cart.",
    "cart.add": "Add to Cart",
    "cart.checkout": "Checkout",
    "cart.removeTitle": "Remove Item",
    "cart.confirmRemoveLong": "Are you sure you want to remove this item from your cart? This action cannot be undone.",
    "cart.confirmRemove": "Are you sure you want to remove this item from your cart?",
    "cart.cancel": "Cancel",
    "cart.removed": "Item Removed",
    "cart.removedDescription": "The item has been removed from your cart.",
    "cart.noneSelected": "No items selected",
    "cart.selectRequired": "Please select at least one item to checkout.",
    "cart.loginRequired": "Login required",
    "cart.loginDescription": "Please sign in or create an account to proceed to checkout.",
    "cart.exclusive": "Anaya Exclusive Collection",
    "cart.sample": "Sample",
    "cart.product": "Product",
    "cart.collection": "• Anaya Collection",
    "cart.gross": "Gross",
    "cart.credit": "Ticket Credit",
    "cart.credits": "Ticket Credits",
    "cart.net": "Net",
    "cart.customPhoto": "Custom photo",
    "cart.edit": "Edit",
    "cart.subtotal": "Subtotal",
    "cart.shipping": "Shipping",
    "cart.free": "Free",
    "cart.unselected": "Unselected items will stay in your cart for later",
    "cart.addCollection": "Add More from Collection",
    "cart.addMore": "Add More",
    "cart.loading": "Loading...",
    "cart.browse": "Browse our collection and add your favorites",
    "cart.shop": "Shop Now",
    "cart.unknown": "Unknown Product",
    "cart.shippingTaxes": "Shipping and taxes calculated at checkout",
    "cart.continue": "Continue Shopping",
    "cart.for": "For {name}",
    "cart.forCountry": "For {name} • {country}",
    "cart.more": "+{count} more",
    "cart.itemCount": "{count} item",
    "cart.itemsCount": "{count} items",
    "cart.selectAll": "Select all ({count} items)",
    "cart.selectedSubtotal": "Subtotal ({selected} of {count} selected)",
    "cart.cartCount": "Your Cart ({count})",
    "cart.size": "{size}ml",
    "cart.close": "Close cart",
    "cart.increase": "Increase quantity",
    "cart.decrease": "Decrease quantity",
    "cart.selectItem": "Select item"
  },
  "ar": {
    "cart.selection": "اختياراتك",
    "cart.title": "سلة التسوق",
    "cart.yourCart": "سلتك",
    "cart.empty": "سلة التسوق فارغة",
    "cart.journey": "ابدأ رحلتك العطرية لابتكار عطرك الخاص.",
    "cart.getStarted": "ابتكر عطرك الخاص للبدء.",
    "cart.create": "ابتكر عطرك",
    "cart.signature": "صندوق أنايا المميز",
    "cart.single": "عطر منفرد",
    "cart.greeting": "✓ بطاقة إهداء مرفقة",
    "cart.photoIncluded": "✓ صورة مرفقة",
    "cart.remove": "إزالة",
    "cart.total": "الإجمالي",
    "cart.addCollectionFull": "أضف المزيد من مجموعة أنايا",
    "cart.addQuiz": "أضف المزيد (خيارات الاستبيان)",
    "cart.proceed": "المتابعة لإتمام الشراء",
    "cart.savedLater": "محفوظة لوقت لاحق",
    "cart.savedDescription": "طلبات محفوظة من مشتريات العينات، يمكنك إكمالها في أي وقت",
    "cart.signatureFallback": "الصندوق المميز",
    "cart.saved": "محفوظ",
    "cart.recipient": "المستلم",
    "cart.added": "تمت الإضافة إلى السلة",
    "cart.savedAdded": "تمت إضافة طلبك المحفوظ إلى السلة.",
    "cart.add": "أضف إلى السلة",
    "cart.checkout": "إتمام الشراء",
    "cart.removeTitle": "إزالة المنتج",
    "cart.confirmRemoveLong": "هل أنت متأكد من إزالة هذا المنتج من سلتك؟ لا يمكن التراجع عن هذا الإجراء.",
    "cart.confirmRemove": "هل أنت متأكد من إزالة هذا المنتج من سلتك؟",
    "cart.cancel": "إلغاء",
    "cart.removed": "تمت إزالة المنتج",
    "cart.removedDescription": "تمت إزالة المنتج من سلتك.",
    "cart.noneSelected": "لم يتم تحديد أي منتجات",
    "cart.selectRequired": "يرجى تحديد منتج واحد على الأقل لإتمام الشراء.",
    "cart.loginRequired": "يلزم تسجيل الدخول",
    "cart.loginDescription": "يرجى تسجيل الدخول أو إنشاء حساب للمتابعة لإتمام الشراء.",
    "cart.exclusive": "مجموعة أنايا الحصرية",
    "cart.sample": "عينة",
    "cart.product": "منتج",
    "cart.collection": "• مجموعة أنايا",
    "cart.gross": "الإجمالي قبل الخصم",
    "cart.credit": "رصيد القسيمة",
    "cart.credits": "أرصدة القسائم",
    "cart.net": "الصافي",
    "cart.customPhoto": "صورة مخصصة",
    "cart.edit": "تعديل",
    "cart.subtotal": "المجموع الفرعي",
    "cart.shipping": "الشحن",
    "cart.free": "مجاني",
    "cart.unselected": "ستبقى المنتجات غير المحددة في سلتك لوقت لاحق",
    "cart.addCollection": "أضف المزيد من المجموعة",
    "cart.addMore": "أضف المزيد",
    "cart.loading": "جارٍ التحميل...",
    "cart.browse": "تصفح مجموعتنا وأضف منتجاتك المفضلة",
    "cart.shop": "تسوق الآن",
    "cart.unknown": "منتج غير معروف",
    "cart.shippingTaxes": "تُحسب تكاليف الشحن والضرائب عند إتمام الشراء",
    "cart.continue": "متابعة التسوق",
    "cart.for": "إلى {name}",
    "cart.forCountry": "إلى {name} • {country}",
    "cart.more": "+{count} إضافية",
    "cart.itemCount": "{count} منتج",
    "cart.itemsCount": "عدد المنتجات: {count}",
    "cart.selectAll": "تحديد الكل ({count} منتج)",
    "cart.selectedSubtotal": "المجموع الفرعي (تم تحديد {selected} من {count})",
    "cart.cartCount": "سلتك ({count})",
    "cart.size": "{size} مل",
    "cart.close": "إغلاق السلة",
    "cart.increase": "زيادة الكمية",
    "cart.decrease": "تقليل الكمية",
    "cart.selectItem": "تحديد المنتج"
  }
};
